import UpdateCatEventForm from 'components/features/update-cat-event-form';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function UpdateCatEvent() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('catEvent.updateCatEvent')}>
      <UpdateCatEventForm />
    </HomeLayout>
  );
}

export default UpdateCatEvent;
